module.exports = __webpack_public_path__ + "static/media/extended-baseplate.a40cd6bb.svg";